import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';
import loader from '../../Assets/App_icon/loader.gif';

const AreaMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');
  const user_role = localStorage.getItem('user_role');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false); 
  const [loading, setLoading] = useState(true);
  
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);

  const [addAreaEName, setAddAreaEName] = useState('');
  const [addAreaName, setAddAreaName] = useState('');

  const handleBack = () => {
    navigate('../dashboard');
  };

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible) {
            setModalVisible(false);
            setAddModalVisible(false);
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert" && !addmodalVisible) {
          setAddModalVisible(true);
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible]);

    useEffect(() => { 
      const fetchAreaList = async () => { 
          setLoading(true);
          try {
            const response = await fetch(`${host_url}/area_list`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                prdlist : '',
              }),
            });
            const data = await response.json();
            setAreas(data);
            setLoading(false);
          } catch (error) {
            console.error('Error fetching cities:', error);
            setLoading(false);
          }
          
      }; 
     fetchAreaList(); 
    }, [host_url, store]);

    

    const [areaIdFilter, setAreaIdFilter] = useState('');
    const [areaNameFilter, setAreaNameFilter] = useState('');
    const [areaENameFilter, setAreaENameFilter] = useState('');
    const [customerFilter, setCustomerFilter] = useState('');

    const filteredAreas = areas.filter(area =>
      String(area.areaId).toLowerCase().includes(areaIdFilter.toLowerCase()) &&
      area.areaName.toLowerCase().includes(areaNameFilter.toLowerCase()) &&
      area.areaEName.toLowerCase().includes(areaENameFilter.toLowerCase()) &&
      String(area.customer).includes(customerFilter)
    );


    const totalCount = filteredAreas.length;
    const totalCustomers = filteredAreas.reduce((sum, area) => sum + Number(area.customer), 0);

    const handleAreaDetail = (area) => {
      setModalVisible(true);
      setSelectedArea(area);
    };

    // Functions for handling the different actions
    const handleAddArea = async () => {
      setAddModalVisible(false);
      try {
        const response = await fetch(`${host_url}/area_list`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'insert',
            store: store,
            areaId : '',
            areaName: addAreaName,
            areaEName: addAreaEName,
          }),
        });
        const data = await response.json();
        setAreas(data);
        setAddAreaEName('');
        setAddAreaName('');
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleUpdateArea = async () => {
      setModalVisible(false);
      try {
        const response = await fetch(`${host_url}/area_list`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'update',
            store: store,
            areaId : selectedArea.areaId,
            areaName: selectedArea.areaName,
            areaEName: selectedArea.areaEName,
          }),
        });
        const data = await response.json();
        setAreas(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleDeleteArea = async () => {
      setModalVisible(false);
      try {
        const response = await fetch(`${host_url}/area_list`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'delete',
            store: store,
            areaId : selectedArea.areaId,
            areaName: selectedArea.areaName,
            areaEName: selectedArea.areaEName,
          }),
        });
        const data = await response.json();
        setAreas(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

  return (
    <div className="container">
      {loading ? (
        <div className="text-center">
          <img src={loader} alt="Back" />
          <p>Loading data...</p>
        </div>
      ) : (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Area Master</b>
              <div onClick={() => setAddModalVisible(true)}>
                <img src={insertlogo} alt="Back" className='system-icon'/>
              </div>
          </div>
         
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th>Area Id</th>
                <th>E_Name</th>
                <th>Name</th>
                <th>Customer</th>
              </tr>
              <tr>
                <th>
                  <input
                    type="text"
                    className="search-input"
                    value={areaIdFilter}
                    onChange={(e) => setAreaIdFilter(e.target.value)}
                  />
                </th>
                <th>
                  <input
                    type="text"
                    className="search-input"
                    value={areaENameFilter}
                    onChange={(e) => setAreaENameFilter(e.target.value)}
                  />
                </th>
                 <th>
                  <input
                    type="text"
                    className="search-input"
                    value={areaNameFilter}
                    onChange={(e) => setAreaNameFilter(e.target.value)}
                  />
                </th>
                <th>
                  <input
                    type="text"
                    className="search-input"
                    value={customerFilter}
                    onChange={(e) => setCustomerFilter(e.target.value)}
                  />
                </th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredAreas.map((row) => {
                  return (
                    <tr key={row.areaId} style={{ lineHeight: '10px' }} onClick={() => handleAreaDetail(row)}>
                      <td className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.areaId}</span></td>
                      <td className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.areaEName}</span></td>
                      <td className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.areaName}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.customer}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left"><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '15px' }}>Total</span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalCustomers}</span></th>
              </tr>
            </tfoot>
          </table>
        </div>  
      )}    

          {/* Modal for Area Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Area Detail</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">Area Id</td>
                        <td className="cell-left">{selectedArea.areaId}</td>
                      </tr>
                      <tr>
                        <td className="cell-left">English Name</td>
                        <td><input type="text" value={selectedArea.areaEName} onChange={(e) => setSelectedArea({ ...selectedArea, areaEName: e.target.value })} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Gujarati Name</td>
                        <td><input type="text" value={selectedArea.areaName} onChange={(e) => setSelectedArea({ ...selectedArea, areaName: e.target.value })} /></td>
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    {selectedArea.customer === 0 && user_role === 'Admin' && (
                      <Button color="danger" style={{ flex: 1, marginRight: '10px' }} onClick={handleDeleteArea}>
                        Delete
                      </Button>
                    )}
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleUpdateArea}>
                      Update
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>

          {/* Modal for Add New Area */}
            <Modal isOpen={addmodalVisible} toggle={() => setModalVisible(!addmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Add New Area</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">English Name</td>
                        <td><input type="text" value={addAreaEName} onChange={(e) => setAddAreaEName(e.target.value)}/></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Gujarati Name</td>
                        <td><input type="text" value={addAreaName} onChange={(e) => setAddAreaName(e.target.value)} /></td>
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleAddArea}>
                      Add New
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setAddModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>  

    </div>
  );
};

export default AreaMaster;
